module.exports = __webpack_public_path__ + "img/zjwm.6e40713a.webp";